import React, { useEffect, useRef } from "react";
import OtpInput from "react-otp-input";
import PropTypes from "prop-types";
import styles from "./OtpInputBox.module.css";

const OTP_LENGTH = 6;

const sanitizeOtp = (raw) => raw.replace(/\D/g, "").slice(0, OTP_LENGTH);

const OtpInputBox = ({ value, changeHandler, autoFocus = false }) => {
  const captureRef = useRef(null);

  useEffect(() => {
    if (!autoFocus || !captureRef.current) return;
    captureRef.current.focus();
  }, [autoFocus]);

  const handleAutofillChange = (e) => {
    changeHandler(sanitizeOtp(e.target.value));
  };

  return (
    <div className={styles.otpWrapper}>
      <div className={styles.otpVisual} aria-hidden="true">
        <OtpInput
          value={value}
          isInputNum
          onChange={changeHandler}
          numInputs={OTP_LENGTH}
          inputStyle={{
            width: "3rem",
            height: "3rem",
            margin: "0 2px",
            fontSize: "2rem",
            borderRadius: 4,
            border: "1px solid rgba(0,0,0,0.3)",
          }}
          separator={<span></span>}
        />
      </div>
      <input
        ref={captureRef}
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={OTP_LENGTH}
        value={value}
        onChange={handleAutofillChange}
        onInput={handleAutofillChange}
        className={styles.otpAutofillCapture}
        aria-label="One-time password"
      />
    </div>
  );
};

OtpInputBox.propTypes = {
  value: PropTypes.string.isRequired,
  changeHandler: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool,
};

export default OtpInputBox;
